module.exports = "//static.hsappstatic.net/FileManagerImages/static-1.19798/images/image-placeholder.png"